import { countryChanged } from "../actions/filters";
import makeSelect from "../../shared/make_select";

const valueSelector = (state) => state.main.filters.country.selectedValue;
const optionsSelector = (state) => state.main.filters.country.options;

export default makeSelect(countryChanged, "Country", valueSelector, optionsSelector, { clearable: true, placeholder: "Choose a country" }, { "col-md-3": true });
